import { useContext, useEffect } from 'react';

import { api } from './api';
import { AppContext } from './contexts';
import { getIosAuthRedirectUrl } from './iosAuth';

let iosAuthApiKeyPromise = null;

function ensureIosAuthApiKey() {
  if (!iosAuthApiKeyPromise) {
    iosAuthApiKeyPromise = api
      .get('/account')
      .then(({ data }) => {
        if (data.apiKeys?.length > 0) {
          return data.apiKeys[0].apiKey;
        }

        return api.post('/account/apiKeys').then(({ data }) => data.apiKey);
      })
      .finally(() => {
        iosAuthApiKeyPromise = null;
      });
  }

  return iosAuthApiKeyPromise;
}

export default function IOSAuthRedirect() {
  const app = useContext(AppContext);

  useEffect(() => {
    let ignore = false;

    ensureIosAuthApiKey()
      .then((apiKey) => {
        if (!ignore) {
          window.location.href = getIosAuthRedirectUrl(apiKey);
        }
      })
      .catch((error) => {
        if (error.isAxiosError) {
          app.handleNetworkError(error);
          return;
        }

        throw error;
      });

    return () => {
      ignore = true;
    };
  }, [app]);

  return null;
}
